history.scrollRestoration = "manual";
document.addEventListener("DOMContentLoaded", function () {
  let player = qs("#player");
  if (player) {
    const player = new Plyr("#player", {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "fullscreen",
      ],
      autoplay: false,
      muted: false,
      clickToPlay: true,
      quality: { default: 1080 },
    });
  }
  let player2 = qs("#player2");
  if (player2) {
    const player2 = new Plyr("#player2", {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "fullscreen",
      ],
      autoplay: false,
      muted: false,
      clickToPlay: true,
      quality: { default: 1080 },
    });
  }
  let player3 = qs("#player3");
  if (player3) {
    const player3 = new Plyr("#player3", {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "fullscreen",
      ],
      autoplay: false,
      muted: false,
      clickToPlay: true,
      quality: { default: 1080 },
    });
  }
  let player4 = qs("#player4");
  if (player4) {
    const player4 = new Plyr("#player4", {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "fullscreen",
      ],
      autoplay: false,
      muted: false,
      clickToPlay: true,
      quality: { default: 1080 },
    });
  }
  let player5 = qs("#player5");
  if (player5) {
    const player5 = new Plyr("#player5", {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "fullscreen",
      ],
      autoplay: false,
      muted: false,
      clickToPlay: true,
      quality: { default: 1080 },
    });
  }

  qsa('[id^="player-d-"], [id^="player-m-"]').forEach(function (el) {
    new Plyr(el, {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "fullscreen",
      ],
      autoplay: false,
      muted: false,
      clickToPlay: true,
      quality: { default: 1080 },
    });
  });

  var navClose = qs(".header__nav-close"),
    headerHamb = qs(".header__hamb");

  if (navClose) {
    headerHamb.onclick = () => {
      qs(".header__nav").classList.add("active");
      document.scrollingElement.style.overflow = "hidden";
      document.scrollingElement.style.height = "100vh";
    };
    navClose.onclick = () => {
      qs(".header__nav").classList.remove("active");
      document.scrollingElement.style.overflow = "initial";
      document.scrollingElement.style.height = "auto";
    };
  }

  window.onscroll = () => {
    //     console.log(window.scrollTop());
    if (document.scrollingElement.scrollTop > 0) {
      qs("#shopify-section-custom-header").classList.add("sticky");
    } else {
      qs("#shopify-section-custom-header").classList.remove("sticky");
    }
  };

  if ($(".collections-single__carousel").hasClass("lifestyle-gallery")) {
    var flkty = new Flickity(".lifestyle-gallery", {
      cellAlign: "left",
      contain: true,
      wrapAround: true,
      groupCells: true,
    });
    flkty.on("staticClick", function (event, pointer, cellElement, cellIndex) {
      fullWrap.classList.add("active");
      full.select(cellIndex);
      focused.focus();
    });
  }
  if ($(".collections-single__carousel").hasClass("lifestyle-gallery-v2")) {
    var flkty = new Flickity(".lifestyle-gallery-v2", {
      cellAlign: "left", 
      contain: true,
      wrapAround: true,
      groupCells: true,
    });
    // flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
    //   fullWrap.classList.add('active');
    //   full.select( cellIndex );
    //   focused.focus();
    // });
  }

  if ($(".collections-single__carousel").hasClass("full-gallery")) {
    var full = new Flickity(".full-gallery", {
      cellAlign: "left", 
      contain: true,
      wrapAround: true,
      groupCells: true,
    });
    var fullWrap = qs(".full-slider"),
      focused = qs(".full-gallery");
    qs(".full-close").onclick = () => {
      fullWrap.classList.remove("active");
    };
  }

  var getVariant = (e) => {
    // checking if variant is selected;
    let key = "";
    $(".swatch_options .swatch").each(function (index, element) {
      // console.log($(element).find('.selected').text().trim());
      key += $(element).find(".selected").text().trim();
      if ($(".add-to-cart--notice").length <= 0) {
        $(".swatch_options").append(
          `<p class="add-to-cart--notice">${window.Shopify.theme_settings.error_select_size}</p>`,
        );
        $(".add-to-cart--notice").hide();
      }
      if (index == 0 && !$(element).find(".selected").text()) {
        $(".add-to-cart--notice").text(
          window.Shopify.theme_settings.error_select_size,
        );
      } else if (index == 1 && !$(element).find(".selected").text()) {
        $(".add-to-cart--notice").text(
          window.Shopify.theme_settings.error_select_sole,
        );
      }
      if (index < $(".swatch_options .swatch").length - 1) {
        key += " / ";
      }
    });
    if (
      $(".swatch_options .swatch .selected").length ==
      $(".swatch_options .swatch").length
    ) {
      // console.log($(`.select > select option:contains("${key}")`).attr('value'));
      let currentVariant = {
        id: $(`.select > select option[data-variant-name="${key}"]`).attr(
          "value",
        ),
        quantity: $(`.select > select option[data-variant-name="${key}"]`).data(
          "quantity",
        ),
        continue: $(`.select > select option[data-variant-name="${key}"]`).data(
          "available",
        ),
        stockLimit: $(
          `.select > select option[data-variant-name="${key}"]`,
        ).data("variant-stock-limit"),
        deliveryTime: {
          default: $(
            `.select > select option[data-variant-name="${key}"]`,
          ).data("delivery-time-default"),
          preorder: $(
            `.select > select option[data-variant-name="${key}"]`,
          ).data("delivery-time-preorder"),
        },
      };
      // $(".select > select").val(currentVariant.id).change();
      $(".add-to-cart--notice").hide();
      return currentVariant;
    } else {
      if ($(".add_to_cart").hasClass("must_be_disabled")) {
        $(".add_to_cart.must_be_disabled").addClass("disabled");
      }
      return false;
    }
  };
  var updateStock = (variant) => {
    // console.log(variant);
    let quantity = variant.quantity;
    let continueSeling = variant.continue;
    let deliveryTime = variant.deliveryTime;
    let stockLimit = variant.stockLimit;

    $(".stock_quantity").detach();
    qs("#sold_out_notification").style.display = "none";

    if (quantity == 1) {
      $(".purchase-details").before(
        `<span class="stock_quantity stock_quantity--only">${window.Shopify.translation.q_only_1_pair} <br/>${deliveryTime.default}</span>`,
      );
    } else if (quantity > 0 && quantity <= 5) {
      var only_few = window.Shopify.translation.q_only_few_pairs.replace(
        "{{quantity}}",
        quantity,
      );
      $(".purchase-details").before(
        `<span class="stock_quantity stock_quantity--only">${only_few}<br/>${deliveryTime.default}</span>`,
      );
    } else if (quantity > 5) {
      $(".purchase-details").before(
        `<span class="stock_quantity stock_quantity--instock">${window.Shopify.translation.q_in_stock}<br/>${deliveryTime.default}</span>`,
      );
    } else if (
      continueSeling == true &&
      quantity <= 0 &&
      quantity > stockLimit
    ) {
      $(".purchase-details").before(
        `<span class="stock_quantity stock_quantity--comingsoon">${window.Shopify.translation.coming_soon}<br/>${deliveryTime.preorder}</span>`,
      );
      qs("#sold_out_notification").style.display = "block";
    } else {
      qs("#sold_out_notification").style.display = "block";
      $(".purchase-details__buttons").addClass("product-is-unavailable");
      $(".add_to_cart .text").text(window.Shopify.translation.sold_out_btext);
    }
  };
  // prevent adding to cart without selecting size
  // $(document).on('click', '.must_be_disabled', function(e){
  //   e.preventDefault();
  // });
  setTimeout(function () {
    var setLink = function (size) {
      console.log("setlink");
      var buttonTextDiff = window.Shopify.translation.find_your_perfect_size;
      buttonTextDiff = buttonTextDiff.replace("{XX}", size);
      var link = `/collections/size-${size}`;
      let diffSizes = `<a href="${link}" class="different-sizes-link">${buttonTextDiff}</a>`;
      if ($(".different-sizes-link") != undefined) {
        $(".different-sizes-link").detach();
      }
      $(".swatch_options").append(diffSizes);
    };

    var footSize = "";
    footSize = window.Cookies.get("size_foot_size");
    if (footSize != undefined) {
      footSize = footSize.replace("EU ", "");
    }

    const $mainProduct = $(".js-product_section").first();
    const $mainAddToCart = $mainProduct.find(".add_to_cart");

    if ($mainAddToCart.hasClass("must_be_disabled")) {
      $mainAddToCart.filter(".must_be_disabled").addClass("disabled");
    } else {
      const $checkedSize = $mainProduct.find(".size-input:checked");
      if ($checkedSize.length) {
        $checkedSize.closest(".swatch-element").addClass("selected");
      }
    }
    if (!$mainProduct.find(".swatch-element").hasClass("selected")) {
      if (footSize != undefined) {
        const $sizeInput = $mainProduct.find(`.size-input[value="${footSize}"]`);
        if ($sizeInput.length) {
          $mainProduct.find(".size-input:checked").prop("checked", false);
          $sizeInput.closest(".swatch-element").addClass("selected");
          $mainProduct
            .find('.single-option-selector[data-option="option1"]')
            .first()
            .val(footSize)
            .trigger("change");
        }
      }
    }
  }, 500);

  $(document).on("click", ".swatch-element label", function (e) {
    //  $(`.single-option-selector`).eq(`${$(this).closest('.swatch').data('option-index')})`).val($(this).text().trim()).trigger('change');
    console.log($(this).text().trim());
    $(`.single-option-selector`)
      .eq($(this).closest(".swatch").data("option-index"))
      .val($(this).text().trim())
      .trigger("change");
    $(this).closest(".swatch").find(".swatch-element").removeClass("selected");
    $(this).parent().addClass("selected");
    var currentVariant = getVariant(this);

    if (currentVariant) {
      $(".add_to_cart").removeClass("disabled").removeClass("must_be_disabled"); //allow add to cart
      updateStock(currentVariant);
    }
    var fSize = $(e.currentTarget)
      .closest(".swatch_options")
      .find('[data-option-index="0"] .selected')
      .data("value");
    // setLink(fSize);
  });

  $(".swatch :radio").change(function () {
    var optionIndex = $(this).closest(".swatch").attr("data-option-index");
    var optionValue = $(this).val();

    $(this)
      .closest("form")
      .find(".single-option-selector")
      .eq(optionIndex)
      .val(optionValue)
      .trigger("change");
  });

  qsa('.product_section a[href*="#"]').forEach(
    (el) =>
      (el.onclick = () => {
        var id = el.getAttribute("href");

        if (qs('[data-popup="' + id + '"]'))
          qs('[data-popup="' + id + '"]').classList.add("active");
      }),
  );
  qsa(".popup__close").forEach(
    (el) =>
      (el.onclick = () => {
        el.closest(".popup").classList.remove("active");
      }),
  );

  let questions = qsa(".question");

  questions.forEach((el) => {
    el.onclick = (e) => {
      let answer = el.nextElementSibling;
      if (el.classList.contains("active")) {
        el.classList.remove("active");
        answer.style.height = "0px";
      } else {
        el.classList.add("active");
        answer.style.height = answer.scrollHeight + 30 + "px";
      }
    };
  });

  function qs(selector, searchIn) {
    return searchIn
      ? searchIn.querySelector(selector)
      : document.querySelector(selector);
  }
  function qsa(selector, searchIn) {
    return searchIn
      ? searchIn.querySelectorAll(selector)
      : document.querySelectorAll(selector);
  }
});
